const localStorageName = "login-token";

export function getToken(): string | null {
    return localStorage.getItem(localStorageName);
}

export function setToken(token: string) {
    localStorage.setItem(localStorageName, token);
}